import Joi from 'joi';
import _ from 'lodash';
import { visualPropEditorDefinitionSchema } from '../../common/joi-validation-schemas';
export const validateUpadateVisualPropsEditorEventPayloadObject = (visualPropsEditorDefinition) => {
    try {
        if (_.isNil(visualPropsEditorDefinition)) {
            throw new Error('visualPropEditorDefinition cannot be empty');
        }
        Joi.assert(visualPropsEditorDefinition, visualPropEditorDefinitionSchema);
    }
    catch (err) {
        throw new Error(err.details[0].message);
    }
};
//# sourceMappingURL=util.js.map